import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { SendPostRequest } from "../http";
import Spinner from "./Spinner";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function HomeFacilities() {
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [isData, setIsData] = useState(false);
  const [show, setShow] = useState(false);
  const [facilitiesIndex, setFacilitiesIndex] = useState();

  const random = Math.round(Math.random() * facilitiesData.length);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    if (!response?.data || response?.data?.length < 1) {
      setIsData(true);
    } else {
      setFacilitiesData(response?.data);
    }
  };

  const handleClose = () => setShow(false);

  const handleShow = (index) => {
    setFacilitiesIndex(index);
    setShow(true);
  };

  // Truncate text with "See more"
  const truncateText = (text, maxLength, index) => {
    if (text.length > maxLength) {
      return (
        <>
          <div
            className="home-Facilities-text d-inline "
            dangerouslySetInnerHTML={{
              __html: text.slice(0, maxLength) + "... ",
            }}
          />
          {/* {text.slice(0, maxLength)}...{" "} */}
          <button
            onClick={() => handleShow(index)}
            className="d-inline see-more-btn"
          >
            Read More
          </button>
        </>
      );
    }
    return text;
  };

  const settings = {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="container">
      <div className="cs_height_50 cs_height_lg_50"></div>

      <div className="featured_services_heading_wrapper mb-5">
        <h2 className="cs_section_title cs_fs_65 m-0 ">Facilities</h2>
        <Link to="/facilities">
          <button className="featured_services_view_btn">View All</button>
        </Link>
      </div>

      <div className="featured_services_desktop">
        <div className="row cs_row_gap_50">
          {facilitiesData?.length === 0 ? (
            <div
              style={{ marginBottom: "100px" }}
              className="d-flex align-items-center justify-content-center "
            >
              <Spinner />
            </div>
          ) : (
            facilitiesData?.length > 0 &&
            facilitiesData
              ?.slice(
                random >= 3 ? random - 3 : random,
                random < 3 ? random + 3 : random
              )
              ?.map((data, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-12">
                  <div className="cs_post cs_style_1 facility-card">
                    {/* <div
                      style={{
                        backgroundImage: `url(${data?.facility_image})`,
                        backgroundPosition: "top center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        height: "250px",
                        width: "100%",
                        cursor: "pointer",
                      }}
                    /> */}
                    <img src={data?.facility_image} alt="facility image" />
                    <div className="cs_post_info ">
                      <div className="facilities-home">
                        <h2 className="cs_post_title cs_semibold cs_fs_32">
                          {data?.facility_title}
                        </h2>
                        {/* <div
                     className="featured-card-wrapper-text"
                      dangerouslySetInnerHTML={{
                        __html:
                          data?.facility_description.slice(0, 170) + "... ",
                      }}
                    /> */}

                        {truncateText(data?.facility_description, 140, index)}
                      </div>
                    </div>
                  </div>
                </div>
              ))
          )}
        </div>
      </div>

      <div className="featured_services_mobile">
        <Slider {...settings}>
          {facilitiesData?.length === 0 ? (
            <div
              style={{ marginBottom: "100px" }}
              className="d-flex align-items-center justify-content-center "
            >
              <Spinner />
            </div>
          ) : (
            facilitiesData?.length > 0 &&
            facilitiesData
              ?.slice(
                random >= 3 ? random - 3 : random,
                random < 3 ? random + 3 : random
              )
              ?.map((data, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-12">
                  <div className="cs_post cs_style_1 facility-card">
                    {/* <div
                      style={{
                        backgroundImage: `url(${data?.facility_image})`,
                        backgroundPosition: "top center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        height: "220px",
                        width: "100%",
                        cursor: "pointer",
                      }}
                    /> */}
                    <img src={data?.facility_image} alt="facility image" />
                    <div className="cs_post_info pb-1">
                      <div className="facilities-home">
                        <h2 className="cs_post_title cs_semibold cs_fs_32">
                          {data?.facility_title}
                        </h2>
                        <p>
                          {truncateText(
                            data?.facility_short_description,
                            105,
                            index
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
          )}
        </Slider>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="review-modal-title">
            {facilitiesData[facilitiesIndex]?.facility_title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: facilitiesData[facilitiesIndex]?.facility_description,
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="review-modal-button"
            variant="btn btn-default"
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default HomeFacilities;
